module.exports = __webpack_public_path__ + "build/img/qua.8511e6fb.png";